import { EUserTitle } from 'src/types/user'
import { ReactNode } from 'react'
import {
  AlertIcon,
  CurecallTooltip,
  GenderFemaleIcon,
  GenderMaleIcon,
  MedicalProfessionalIcon,
  CurecallToggle,
} from '@honestica/curecall-ui'
import { TMedicalStaffMember } from 'src/types/medical-staff-member'
import { useState } from 'react'
import { getDoctorCivilityAndName } from 'src/utils/string-formatter.util'

export const ActivateCell = (props: {
  onActivateMedicalStaffMember: VoidFunction
  isMedicalStaffMemberActive: boolean
  tooltipLabel: string
}) => {
  const [isEnabled, setIsEnabled] = useState(props.isMedicalStaffMemberActive)
  return (
    <div className={'c-flex c-items-center c-h-6 c-gap-1.5 c-text-orange-700'}>
      <CurecallTooltip
        content={props.tooltipLabel}
        tooltipPosition="bottom-start"
        wrapperClassName="tw-w-max"
      >
        <CurecallToggle
          isEnabled={isEnabled}
          onChange={() => {
            setIsEnabled((prev: boolean) => !prev)
            props.onActivateMedicalStaffMember()
          }}
        />
      </CurecallTooltip>
    </div>
  )
}

export const TitleIconCell = (props: { civility: EUserTitle | undefined }) => {
  const ICON_OPTIONS: Record<EUserTitle, ReactNode> = {
    'Dr.': <MedicalProfessionalIcon />,
    'Pr.': <MedicalProfessionalIcon />,
    'Mme.': <GenderFemaleIcon />,
    'M.': <GenderMaleIcon />,
  }
  return <div className="c-w-[24px]">{props.civility ? ICON_OPTIONS[props.civility] : undefined}</div>
}

export const IdentityCell = (
  props: Pick<TMedicalStaffMember, 'civility' | 'firstname' | 'lastname' | 'professionalCode'>,
) => {
  return (
    <div className="c-flex c-items-center c-gap-1.5">
      <span>{getDoctorCivilityAndName(props)}</span>
      {props.professionalCode !== '10' && (
        <CurecallTooltip
          content="Attention, ce professionnel a un code professionnel différent de 10 (Médecin) et ne sera donc pas affiché dans les sélecteurs de l'application."
          tooltipPosition="right"
          wrapperClassName="c-flex"
        >
          <AlertIcon className="c-h-4 c-w-4 c-shrink-0 c-text-orange-500" />
        </CurecallTooltip>
      )}
    </div>
  )
}
